import React from 'react'


import logo from '../../assets/logo-min.svg'

export default function Brand(){
  return (
    <>
    <img src={logo} alt="Company Logo" style={{height: "85%"}} /><h1 style={{color: "white", position: "absolute", left:90}}>Play404 </h1>
    </>
  )
}


